import React from "react";
import { Col, Input } from "antd";

import search_icon from "../../../assests/images/search-icon.svg";
import back_arrow from "../../../assests/images/master/back-arrow.svg";

import "./index.scss";
import { useNavigate } from "react-router";
import constants from "../../../constants/constants";

const { ROLES } = constants;
const { ROLE_MD } = ROLES;

const MasterSearch = ({
  title,
  search,
  masterSearch,
  masterSearchPlaceholder,
  isSearchPresent,
  setVisibleMasterList
}) => {
  const navigate = useNavigate();
  const goToPreviousPage = () => {
    if (typeof setVisibleMasterList === "function") {
      setVisibleMasterList();
      return;
    }
    // Get user roles
    const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
    const userRoles = userinfo?.roles || [];

    // Redirect to Director Dashboard if MD role
    if (userRoles.includes(ROLE_MD)) {
      navigate("/director-dashboardNew2");
    } else {
      navigate("/masters");
    }
  };

  return (
    <Col span={24}>
      <div className="master-search-container">
        {
          isSearchPresent ?
            <>
              <span className="d-flex">
                {masterSearch ? <img
                  src={back_arrow}
                  onClick={() => {
                    if (typeof setVisibleMasterList === "function") {
                      setVisibleMasterList();
                      return;
                    }
                    const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
                    const userRoles = userinfo?.roles || [];
                    if (userRoles.includes(ROLE_MD)) {
                      navigate("/director-dashboardNew2");
                    } else {
                      navigate("/dashboard");
                    }
                  }}
                  className="pointer"
                /> : (
                  <img
                    src={back_arrow}
                    onClick={() => goToPreviousPage()}
                    className="pointer"
                  />
                )}
                &nbsp;{title}
              </span>
              {masterSearch && (
                <div>
                  <Input
                    placeholder={masterSearchPlaceholder}
                    bordered
                    onChange={search}
                    style={{ borderRadius: "5px", height: "40px" }}
                    suffix={<img src={search_icon} />}
                  />
                </div>
              )}
            </>
            :
            <span className="d-flex">
              <img
                src={back_arrow}
                onClick={() => {
                  if (typeof setVisibleMasterList === "function") {
                    setVisibleMasterList();
                    return;
                  }
                  const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
                  const userRoles = userinfo?.roles || [];
                  if (userRoles.includes(ROLE_MD)) {
                    navigate("/director-dashboardNew2");
                  } else {
                    navigate("/dashboard");
                  }
                }}
                className="pointer"
              />  &nbsp;{title}
            </span>
        }
      </div>
    </Col>
  );
};
export default MasterSearch;
